
export const createJsonStore = (key, store) => ({
    get: () => {
        const cacheStr = store.getItem(key);

        if (cacheStr == null) {
            return undefined;
        }

        return JSON.parse(cacheStr);
    },
    set: (value) => {
        if (value == null) {
            store.removeItem(key);
        } else {
            store.setItem(key, JSON.stringify(value));
        }
    },
});
